<style>
    .modal-backdrop.fade {
        opacity: 0;
    }

    .modal-backdrop {
        position: initial;
    }
    #content-wrapper{
        min-height: 915px !important;
    }
</style>

<div id="content-wrapper">
    <div class="row">
        <div class="col-lg-12">
            <div class="slide-main-container">
                <div class="container slide-main-animation">
                    <div class="row">
                        <div class="col-xs-12" *ngIf="!loadingFlag">
                            <div id="login-box" *ngIf="!authenticatedFlag">
                                <div id="login-box-holder">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <header id="login-header">
                                                <div id="login-logo">
                                                    <img [src]="imageUrl + 'logo-symbol.png'" alt="" />
                                                </div>
                                            </header>
                                            <div id="login-box-inner">
                                                <app-authenticate-token [token]="token"
                                                    [email]="email"
                                                    [companyId]="companyId"
                                                    (successCallback)="successCallback($event)"
                                                    (errorCallback)="errorCallback($event)">
                                                </app-authenticate-token>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="performAction" *ngIf="authenticatedFlag" class="main-box">
                                <div class="main-box-body">
                                    <div *ngIf="action == 'Interview' || action == 'PhoneScreen' || action == 'RecruiterScreening'">
                                        <app-feedback-execution
                                            [feedbackUserIdsList]="userIdsArray"
                                            [feedbackType]="action"
                                            [jobMatchId]="tokenData.jobMatchId"
                                            [parentScheduleId]="tokenData.meetingScheduleId"
                                            [loginRequired]="false"
                                            [externalCommentRequired]="tokenData.addExternalComment"
                                            (completeFeedbackCallback)="actionSaveCallback()">
                                        </app-feedback-execution>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12" *ngIf="loadingFlag">
                            <div id="login-box">
                                <div id="login-box-holder">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <header id="login-header">
                                                <div id="login-logo">
                                                    <img [src]="imageUrl + 'logo-symbol.png'" alt="" />
                                                </div>
                                            </header>
                                            <div id="login-box-inner">
                                                <app-skeleton-loader variant="form" [rows]="1"></app-skeleton-loader>
                                                <app-skeleton-loader variant="block" [rows]="1"></app-skeleton-loader>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
